"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Snackbar = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var internal_1 = require("../../internal");
var Snackbar = function (_a) {
    var actionName = _a.actionName, className = _a.className, _b = _a.duration, duration = _b === void 0 ? 5000 : _b, onActionClick = _a.onActionClick, onClose = _a.onClose, _c = _a.portal, portal = _c === void 0 ? true : _c, title = _a.title, props = __rest(_a, ["actionName", "className", "duration", "onActionClick", "onClose", "portal", "title"]);
    var _d = react_1.useState(true), visible = _d[0], setVisible = _d[1];
    var snackbarRef = react_1.useRef(null);
    var handleClose = react_1.default.useCallback(function (e) {
        setVisible(false);
        if (onClose)
            onClose(e);
        if (snackbarRef.current != null)
            clearTimeout(snackbarRef.current);
    }, [onClose]);
    react_1.useEffect(function () {
        if (duration === null || duration === 0)
            return;
        snackbarRef.current = setTimeout(function () { return handleClose(); }, duration);
        return function () { return clearTimeout(snackbarRef.current); };
    }, [duration, handleClose]);
    if (!visible)
        return null;
    var SnackbarClasses = classnames_1.default('Snackbar', className, {
        'Snackbar--floating': portal,
    });
    var snackbar = (react_1.default.createElement("div", __assign({ className: SnackbarClasses }, props),
        title && react_1.default.createElement("div", { className: "Snackbar__title" }, title),
        actionName && onActionClick && (react_1.default.createElement("div", { onClick: onActionClick, className: "Snackbar__action" }, actionName)),
        onClose && (react_1.default.createElement(__1.Button, { fill: "subtle", className: "Snackbar__close", iconName: "clear", size: "xsmall", onClick: handleClose }))));
    return react_1.default.createElement(internal_1.Portal, { conditional: portal }, snackbar);
};
exports.Snackbar = Snackbar;
//# sourceMappingURL=Snackbar.js.map